module.exports = __webpack_public_path__ + "img/marija-tiurina-the-breakfast-cart.412fb93.jpg";